import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import { getRolesData, actionCreators as rolesActionCreators } from "../roles";
import actionCreators from "./redux/actionCreators";
import { getInProgress, getUserStatusDictionary, getUsersData } from "./redux/selectors";
import Users from "./users";
const canDelete = security.isAllowed([Permissions.UsersDelete]);
const canEdit = security.isAllowed([Permissions.UsersEdit]);
const mapStateToProps = (state) => ({
    data: getUsersData(state),
    roles: getRolesData(state),
    userStatusDictionary: getUserStatusDictionary(state),
    inProgress: getInProgress(state),
    canDelete,
    canEdit
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(actionCreators.getUserStatusDictionary());
        dispatch(actionCreators.getUsers());
        dispatch(rolesActionCreators.getRoles());
    },
    onDeleted: (ids) => dispatch(actionCreators.removeUsers(ids)),
    onBlocked: (ids) => dispatch(actionCreators.blockUsers(ids)),
    onUnblocked: (ids) => dispatch(actionCreators.unblockUsers(ids)),
    onSaveUser: (data) => dispatch(actionCreators.saveUser(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(Users);
